import axios from 'axios';

export const getPaymentModes = async () => {
  const response = await axios.get('/payment-mode');

  return response;
};

